module.exports = __webpack_public_path__ + "static/group-split-b0e46343ac9346937ddbc77676d8f7cf.png";